import {
  useHotelsStyles,
  useModuleBEM,
  useTenantImages,
} from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { PageLoadingScreen } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./HotelListLoading.module.scss";

export interface HotelListLoadingComponentProps extends PlatformComponentProps {
  isLoading?: boolean;
}
export const HotelListLoading = ({
  isLoading,
  className,
  children,
}: HotelListLoadingComponentProps) => {
  const styles = useHotelsStyles(
    CoreHotelsComponent.HotelListLoading,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(
    styles,
    CoreHotelsComponent.HotelListLoading
  );

  const { t } = useI18nContext();

  const images = useTenantImages();

  return (
    <PageLoadingScreen
      isLoading={isLoading}
      backgroundImage={images.hotelLoadingImage}
      className={clsx(block, className)}
      text={t("core-hotels.availabilityPage.loadingScreen.title")}
      subtitle={t("core-hotels.availabilityPage.loadingScreen.subtitle")}
    >
      {children}
    </PageLoadingScreen>
  );
};
